import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'; 

@Pipe({
  name: 'qdatefull'
})
export class QdatefullPipe implements PipeTransform {

 
  transform(value: any, args?: any): any {
    
    return moment(value).format('YYYY-MM-DD hh:mm a');
  }

}
